<template>
  <div
    v-if="showIcon"
    v-clipboard:copy="toCopy"
    v-clipboard:success="onCopy"
    v-tippy="{
      content: copied ? t('ui.messages.copied') : t('ui.messages.copyToClipboard'),
      trigger: 'mouseenter click'
    }"
  >
    <slot></slot>
    <Icon
      type="copy"
      class="text-light dark:text-secondary ml-2 copy-icon"
    />
  </div>
  <div
    v-else
    v-clipboard:copy="toCopy"
    v-clipboard:success="onCopy"
    v-tippy="{
      content: copied ? t('ui.messages.copied') : t('ui.messages.copyToClipboard'),
      trigger: 'mouseenter click'
    }"
    class="copy-text"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'
import { ref, computed, useSlots } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  showIcon: {
    type: Boolean,
    default: false
  },
  explicitTextToCopy: {
    type: String,
    default: null
  }
})

const slots = useSlots()
const copied = ref(false)

const toCopy = computed(() => {
  if (props.explicitTextToCopy) {
    return props.explicitTextToCopy
  }
  const slot = slots.default?.()[0]
  return slot && slot.children ? slot.children : t('ui.messages.nothingToPaste')
})

function onCopy() {
  copied.value = true
  setTimeout(() => {
    copied.value = false
  }, 2000)
}
</script>

<style>
.copy-icon {
  font-size: 1rem;
}
.copy-icon:hover,
.copy-text:hover {
  color: var(--fg-brand);
  cursor: pointer;
}
</style>
